module.exports = __webpack_public_path__ + "img/gi.0ad62abd.svg";